"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyNewsletterPhotosIfResolved = exports.applyEventRecapPhotosIfResolved = exports.NEWSLETTER_PHOTO_IMAGE_IDS = exports.EVENT_RECAP_PHOTO_IMAGE_IDS = exports.EVENT_RECAP_PHOTO_CONTAINER_ID = void 0;
const default_banner_urls_1 = require("../constants/default-banner-urls");
const photoCropUrls_1 = require("./photoCropUrls");
const waypointBlocks_1 = require("./waypointBlocks");
exports.EVENT_RECAP_PHOTO_CONTAINER_ID = "block-2bd83732-f9a7-42b3-8643-277523326382";
exports.EVENT_RECAP_PHOTO_IMAGE_IDS = [
    "block-d3b954ae-2d61-4415-bedd-0a332d003503",
    "block-996628de-2de1-4fe4-81b8-0c09cc9a99db",
    "block-de8a1187-b3bc-4f3c-be50-e8fd0c2977fb",
];
exports.NEWSLETTER_PHOTO_IMAGE_IDS = [
    "block-2f7226fb-7adf-4fd4-80de-6b8ae8e75f5c",
    "block-efff4d33-2ea7-4cb7-800d-7855b695797b",
];
const applyEventRecapPhotosIfResolved = (template, photos) => {
    if (!photos || !template[exports.EVENT_RECAP_PHOTO_CONTAINER_ID]) {
        return;
    }
    const usedPhotos = photos.slice(0, exports.EVENT_RECAP_PHOTO_IMAGE_IDS.length);
    if (usedPhotos.length === 0) {
        removePhotoGrid(template);
        return;
    }
    usedPhotos.forEach((photo, index) => {
        const image = template[exports.EVENT_RECAP_PHOTO_IMAGE_IDS[index]];
        if (image?.data?.props) {
            image.data.props.url = (0, photoCropUrls_1.buildLandscapePhotoUrl)(photo.url);
            image.data.props.alt = photo.alt ?? image.data.props.alt;
        }
    });
    shrinkPhotoGridToCount(template, usedPhotos.length);
};
exports.applyEventRecapPhotosIfResolved = applyEventRecapPhotosIfResolved;
const shrinkPhotoGridToCount = (template, photoCount) => {
    if (photoCount >= exports.EVENT_RECAP_PHOTO_IMAGE_IDS.length) {
        return;
    }
    for (const imageId of exports.EVENT_RECAP_PHOTO_IMAGE_IDS.slice(photoCount)) {
        delete template[imageId];
    }
    const container = template[exports.EVENT_RECAP_PHOTO_CONTAINER_ID];
    if (container?.type !== "ColumnsContainer") {
        return;
    }
    if (photoCount === 1) {
        template[exports.EVENT_RECAP_PHOTO_CONTAINER_ID] = {
            type: "Container",
            data: {
                style: container.data.style ?? undefined,
                props: { childrenIds: [exports.EVENT_RECAP_PHOTO_IMAGE_IDS[0]] },
            },
        };
        return;
    }
    const props = container.data.props;
    if (props) {
        props.columnsCount = 2;
        if (props.columns?.[2]) {
            props.columns[2] = { childrenIds: [] };
        }
    }
};
const removePhotoGrid = (template) => {
    (0, waypointBlocks_1.removeBlocksAndCleanReferences)(template, (0, waypointBlocks_1.getAllBlockIdsToDelete)(exports.EVENT_RECAP_PHOTO_CONTAINER_ID, template));
};
const applyNewsletterPhotosIfResolved = (template, photos) => {
    if (!photos) {
        return;
    }
    exports.NEWSLETTER_PHOTO_IMAGE_IDS.forEach((imageId, index) => {
        const image = template[imageId];
        if (!image?.data?.props) {
            return;
        }
        const photo = photos[index];
        image.data.props.url = (0, photoCropUrls_1.buildSquarePhotoUrl)(photo?.url ?? default_banner_urls_1.donationFormDefaultBannerV2Url);
        if (photo?.alt) {
            image.data.props.alt = photo.alt;
        }
    });
};
exports.applyNewsletterPhotosIfResolved = applyNewsletterPhotosIfResolved;
